import { sendPasswordResetEmail } from 'firebase/auth';
import { firebaseAuth } from '../firebase';

/** URL après réinitialisation (Firebase Console → Auth → Modèles d’email : domaines autorisés requis). */
export function getPasswordResetContinueUrl() {
  const explicit = process.env.REACT_APP_PASSWORD_RESET_CONTINUE_URL?.trim();
  if (explicit) return explicit;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/login`;
  }
  return '';
}

/**
 * Envoie l’email officiel Firebase « réinitialisation du mot de passe ».
 * Message utilisateur volontairement neutre (pas d’énumération d’emails).
 */
export async function sendFirebasePasswordResetEmail(email) {
  const trimmed = (email || '').trim().toLowerCase();
  if (!trimmed) {
    return { success: false, error: 'Indiquez votre adresse email.' };
  }
  if (!firebaseAuth) {
    return { success: false, error: 'Firebase Auth n’est pas configuré.' };
  }
  const continueUrl = getPasswordResetContinueUrl();
  if (!continueUrl) {
    return { success: false, error: 'URL de retour invalide (configurez REACT_APP_PASSWORD_RESET_CONTINUE_URL).' };
  }
  try {
    await sendPasswordResetEmail(firebaseAuth, trimmed, {
      url: continueUrl,
      handleCodeInApp: false,
    });
    return { success: true };
  } catch (err) {
    const code = err?.code;
    if (code === 'auth/user-not-found') {
      return { success: true };
    }
    const map = {
      'auth/invalid-email': 'Adresse email invalide.',
      'auth/too-many-requests': 'Trop de demandes. Réessayez dans quelques minutes.',
    };
    return {
      success: false,
      error: map[code] || err?.message || 'Impossible d’envoyer l’email.',
    };
  }
}
